<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Analysis',
})
</script>
<template>
  <div>
    <a-row :gutter="24">
      <!-- 总销售额 -->
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }" v-for="(item,i) in staticData" :key="i">
        <chart-card :loading="loading" :title="item.text" :total="item.id">
          <template #action>
            <a-tooltip>
              <template #title>{{ $t('dashboard.analysis.introduce') }}</template>
              <info-circle-outlined />
            </a-tooltip>
          </template>
          <div style="height:50px;">
            <mini-bar :id="'payments_'+i" />
          </div>
          <template #footer v-if="item.sub">
             <div v-if="item.sub=='onoff'" class="flex align-center">
                <div v-for="(it,u) in item.data" :key="u" class="margin-right-xs">
                    <span class="text-sm text-gray margin-right-xs">{{ it.text }}</span>
                    <span :class="it.id==0?'text-red':'text-green'" >{{ it.data }}</span>
                </div>
             </div>
             <div v-else-if="item.sub=='alarm'" class="flex align-center">
                <div v-for="(it,u) in item.data" :key="u" class="margin-right-xs">
                    <span class="text-sm text-gray  margin-right-xs">{{ it.text }}</span>
                    <span v-if="it.id==1" class="text-yellow">{{ it.data }}</span>
                    <span v-else-if="it.id==2" class="text-orange">{{ it.data }}</span>
                    <span v-else-if="it.id==3" class="text-red">{{ it.data }}</span>
                </div>
             </div>
            <span v-else>{{ item.sub }}</span>
          </template>
        </chart-card>
      </a-col>

    </a-row>

    <!-- 存煤量 -->
    <a-card :loading="loading" title="库存煤量" :bordered="false" :body-style="{ padding: '0' }">
      <template #extra>
          <div class="extra-wrapper">
              <div class="extra-item">
                <a>{{ $t('dashboard.analysis.all-day') }}</a>
                <a>{{ $t('dashboard.analysis.all-week') }}</a>
                <a>{{ $t('dashboard.analysis.all-month') }}</a>
                <a>{{ $t('dashboard.analysis.all-year') }}</a>
              </div>
              <a-range-picker :style="{ width: '256px' }" />
            </div>
      </template>
      <div class="salesCard">
         <a-row>
              <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
                <bar :data="barData" title="" id="sales" />
              </a-col>
              <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                 <div   v-for="(item,i) in rankList" :key="i" class="flex align-center devider padding-tb-xs margin">
                    <span >{{ item.DeviceGroupName }}</span>
                    <span style="width:200px;">
                      <a-slider :value="(item.Weight/item.FullWeight)*100"></a-slider>
                    </span>
                    <span class="margin-left">{{ item.Weight }}吨</span>
                 </div>
              </a-col>
            </a-row>
      </div>
    </a-card>

    <div class="antd-pro-pages-dashboard-analysis-twoColLayout" :class="!isMobile && 'desktop'">
      <a-row :gutter="24" type="flex" :style="{ marginTop: '24px' }">
        <!-- 线上热门搜索 -->
        <a-col :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
           <worklogs />
        </a-col>
        <!-- 销售额类别占比 -->
        <a-col :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
            <workgroup style="min-height:780px" />
        </a-col>
      </a-row>

    </div>
  </div>
</template>

<script lang="ts" setup name="Analysis">
import { ref, computed, onMounted } from 'vue'
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'
import { isMobile } from '@/utils/device'
import { InfoCircleOutlined, EllipsisOutlined } from '@ant-design/icons-vue'
import ChartCard from './components/Charts/ChartCard.vue'
import Trend from './components/Charts/Trend.vue'
import MiniArea from './components/Charts/MiniArea.vue'
import MiniBar from './components/Charts/MiniBar.vue'
import MiniProgress from './components/Charts/MiniProgress.vue'
import RankList from './components/Charts/RankList.vue'
import Bar from './components/Charts/Bar.vue'
import NumberInfo from './components/NumberInfo/NumberInfo.vue'
import MiniSmoothArea from './components/Charts/MiniSmoothArea.vue'
import Pie from './components/Charts/Pie.vue'

import worklogs from '@/components/lanseed/worklogs.vue'
import workgroup from '../account/workgroup.vue'
import charts from '@/components/lanseed/charts.vue'

import {http} from '@/utils/http/service'
// info:todo:当g2设置 {yAxis: false,smooth: true}时,会出现最高点显示不全的问题,官网示例也是如此,解决方法:设置中加padding: [5, 0, 0, 0]

const { t } = useI18n()
// created
const loading = ref<boolean>(true)
const staticData=ref([])
const barData: any = []
const barData2: any = []

const rankList: any = ref([])

const searchUserData: any = []
for (let i = 0; i < 7; i++) {
  searchUserData.push({
    x: dayjs().add(i, 'days').format('YYYY-MM-DD'),
    y: Math.ceil((Math.random() + 1) * 10)
  })
}
const searchUserScale = [
  {
    dataKey: 'x',
    alias: '时间'
  },
  {
    dataKey: 'y',
    alias: '用户数',
    min: 0,
    max: 10
  }
]

const searchData: any = []
for (let i = 0; i < 50; i += 1) {
  searchData.push({
    index: i + 1,
    keyword: `搜索关键词-${i}`,
    count: Math.floor(Math.random() * 1000),
    range: Math.floor(Math.random() * 100),
    status: Math.floor((Math.random() * 10) % 2)
  })
}

const sourceData = [
  { item: '家用电器', count: 32.2 },
  { item: '食用酒水', count: 21 },
  { item: '个护健康', count: 17 },
  { item: '服饰箱包', count: 13 },
  { item: '母婴产品', count: 9 },
  { item: '其他', count: 7.8 }
]

const searchTableColumns = computed(() => [
  {
    dataIndex: 'index',
    title: t('dashboard.analysis.table.rank'),
    width: 90
  },
  {
    dataIndex: 'keyword',
    title: t('dashboard.analysis.table.search-keyword')
  },
  {
    dataIndex: 'count',
    title: t('dashboard.analysis.table.users')
  },
  {
    key: 'range',
    title: t('dashboard.analysis.table.weekly-range'),
    align: 'right',
    sorter: (a, b) => a.range - b.range
  }
])

onMounted(()=>{
    http.get('/APP/GetDeviceGroupStatic').then(res=>{

      if(res.state==1){
        rankList.value=res.data
        res.data.forEach(e => {

          barData.push({x:e.DeviceGroupName,y:e.Weight})
        });
      }
    })
     http.get('/APP/getStaticInfo').then(res=>{
      loading.value=false
        if(res.state==1){
            staticData.value=res.data
        }
      })
})



const salesTypeRadio = ref<string>('a')
</script>

<style lang="less" scoped>
@import '@/style/index.less';

.extra-wrapper {
  line-height: 55px;
  padding-right: 24px;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }
}

.antd-pro-pages-dashboard-analysis-twoColLayout {
  position: relative;
  display: flex;
  display: block;
  flex-flow: row wrap;
}

.antd-pro-pages-dashboard-analysis-salesCard {
  height: calc(100% - 24px);

  ::v-deep(.ant-card-head) {
    position: relative;
  }
}

.dashboard-analysis-iconGroup {
  i {
    margin-left: 16px;
    color: rgba(0, 0, 0, 0.45);
    cursor: pointer;
    transition: color 0.32s;
  }
}

.analysis-salesTypeRadio {
  position: absolute;
  right: 54px;
  bottom: 12px;
}

::v-deep(.ant-table-row) {
  color: rgba(0, 0, 0, 0.65);

  &:hover {
    background-color: #fff1f0;
  }
}

::v-deep(.ant-table-tbody) {
  &>tr.ant-table-row:hover {
    &>td {
      background-color: #fff1f0;
    }
  }
}

.darkMode {
  .dashboard-analysis-iconGroup {
    i {
      color: @dark-deactive-font-color;
    }
  }

  .ant-table-wrapper {
    ::v-deep(.ant-table-cell) {
      color: @dark-deactive-font-color;
    }

    ::v-deep(.ant-table-tbody) {
      .ant-table-row:hover {
        background-color: rgb(38, 38, 38) !important;
      }
    }
  }
}
</style>
